<template>
  <div style="height: 90px;">
    <header>
    <div class="header-main">
      <nuxt-link to="/">
        <img class="logo-img" src="../assets/img/logo.png" alt="logo">
      </nuxt-link>
      <ul class="nav">
        <li v-for="(item,index) in navs" :key="index">
          <nuxt-link :to="item.url">{{ item.title }}</nuxt-link>
          <ul class="sub-nav" v-if="item.children">
            <li class="sub-nav-item" v-for="(son,i) in item.children" :key="i">
              <nuxt-link :to="son.url">
                {{ son.title }}
              </nuxt-link>
              <!--<ul class="sub-sub-nav" v-if="son.children">
                <li class="sub-sub-nav-item" v-for="(cate,cateIndex) in son.children" :key="cateIndex" v-show="!cate.isShow">
                  <nuxt-link :to="cate.url">{{ cate.title }}</nuxt-link>
                </li>
              </ul>-->
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </header>
  </div>
</template>

<script setup lang="ts">
import { nav } from '@/data/data'
import type { navItem } from '@/data/data'
const navs = reactive<Array<navItem>>(nav)
</script>

<style lang="stylus" scoped>
header
  width 100%
  background #061a1f
  opacity .9
  position fixed
  z-index 10
  .header-main
    max-width 1510px
    min-width 1280px
    height 100%
    margin auto
    padding 0 50px
    box-sizing border-box
    display flex
    align-items center
    justify-content space-between
    .logo-img
      aspect-ratio: auto 300 / 100
      height 88px
    .nav
      height 100%
      display flex
      &>li
        line-height 88px
        color #AAA
        font-weight 500
        font-size 16px
        position relative
        &>.router-link-active
          border-bottom 3px solid #1E8BAC
          box-sizing border-box
          color #3B3B3B!important
        &:hover > a
          color #3B3B3B
          border-bottom 3px solid #1E8BAC
          box-sizing border-box
        &>a
          transition display 0.3s linear
          display inline-block
          padding 0 18px
          height 100%
          color inherit
        &:hover .sub-nav
          display block
        .sub-nav
          display none
          background #061a1f
          position absolute
          margin-top -3px
          left 0
          min-width 320px
          border-top 3px solid #1E8BAC
          line-height 40px
          font-size 14px
          box-sizing border-box
          .sub-nav-item
            box-sizing border-box
            padding 0 20px
            position relative
            &:hover
              background #1E8BAC
              color #FFF
              &>a
                display inline-block
                height 100%
                width 100%
                color #FFF
              .sub-sub-nav
                display block
            .sub-sub-nav
              display none
              background #061a1f
              min-width 250px
              position absolute
              right 100%
              top 0
              &-item
                padding 0 20px
                &:hover
                  background #1E8BAC
                  a
                    color #FFF
                    display inline-block
                    height 100%


</style>
